<template>
  <div class="predictive-search-empty grid">
    <div class="col xs-span l3">
      <div v-if="searchQuery && isMobile">
        <h3
          class="predictive-search-empty__title text-body-m-bold"
          v-text="$string('predictive_search.no_results_title')"
        />
        <p
          class="text-body-s-regular predictive-search-empty__no-results"
          v-html="
            $string(
              'predictive_search.no_results',
              {
                replace: {
                  term: `<span class='text-body-s-bold'>${searchQuery}</span>`
                }
              },
            )
          "
        />
      </div>

      <div class="predictive-search-empty__blocks">
        <div
          v-if="popularTerms.length"
          class="predictive-search-empty__block"
        >
          <h3
            class="predictive-search-empty__title text-body-m-bold"
            v-text="$string('predictive_search.popular_searches')"
          />

          <ul class="predictive-search-empty__list">
            <li
              v-for="term of popularTerms"
              :key="term"
            >
              <a
                :href="`${$variable('routes.search')}?q=${term}`"
                class="text-body-s-regular"
                v-text="term"
              />
            </li>
          </ul>
        </div>

        <div
          v-if="helpfulLinks.length"
          class="predictive-search-empty__block"
          :class="{ 'no-border': searchQuery }"
        >
          <h3
            class="predictive-search-empty__title text-body-m-bold"
            v-text="$string('predictive_search.helpful_link')"
          />

          <ul class="predictive-search-empty__list">
            <li
              v-for="term of helpfulLinks"
              :key="term"
            >
              <a
                class="text-body-s-regular"
                :href="term.url"
                v-text="term.title"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="col xs-span l4-12"
    >
      <div v-if="searchQuery && !isMobile">
        <h3
          class="predictive-search-empty__title text-body-m-bold"
          v-text="$string('predictive_search.no_results_title')"
        />
        <p
          class="text-body-s-regular"
          v-html="
            $string(
              'predictive_search.no_results',
              {
                replace: {
                  term: `<span class='text-body-s-bold'>${searchQuery}</span>`
                }
              },
            )
          "
        />
      </div>

      <template v-if="!searchQuery && popularCollections.length">
        <h3
          class="
            predictive-search-empty__title
            text-body-m-bold
            predictive-search-empty__collections-title
          "
          v-text="$string('predictive_search.popular_collections')"
        />

        <content-carousel
          :cards="popularCollections"
          :container="false"
          card-type="search"
          class="
            predictive-search-empty__list
            predictive-search-empty__collections-list
          "
          cta-class-label="text-other-button-xs"
        />
      </template>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Predictive search empty (predictive-search-empty)
 * -----------------------------------------------------------------------------
 * Component to display predictive search empty.
 *
 * @param {String} searchQuery - Current search query.
 *
 */
import { mapState } from 'vuex'

import ContentCarousel from '~async/content-carousel/content-carousel.vue'

export default {
  name: 'PredictiveSearchEmpty',

  components: {
    ContentCarousel,
  },

  props: {
    searchQuery: {
      type: String,
      default: '',
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Returns popular collections that are set in theme settings
     * @returns {Array}
     */
    popularCollections() {
      return cnvs.settings.search?.popularCollections || []
    },

    /**
     * Returns helpful links that are set in theme settings
     * @returns {Array}
     */
    helpfulLinks() {
      return cnvs.settings.search?.helpfulLinks || []
    },

    /**
     * Returns popular terms that are set in theme settings
     * @returns {Array}
     */
    popularTerms() {
      return cnvs.settings.search?.popularTerms?.slice(0, 3) || []
    },
  },
}
</script>
